import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import NativeSelect from '@material-ui/core/NativeSelect'

const styles = theme => ({
  formControl: {
    minWidth: 120,
    marginTop: 15,
    width: '100%'
  },
  cssLabel: {
    '&$cssFocused': {
      color: 'rgba(0, 0, 0, 0.54)'
    }
  },
  cssFocused: {}
})

class DropDown extends React.Component {
  render() {
    const { classes, placeholder, options, value, onChange } = this.props

    return (
      <FormControl className={classes.formControl}>
        <InputLabel
          shrink
          FormLabelClasses={{
            root: classes.cssLabel,
            focused: classes.cssFocused
          }}
        >
          {placeholder}
        </InputLabel>
        <NativeSelect
          value={[value]}
          onChange={event => onChange(event.target.value)}
          input={<Input fullWidth />}
          fullWidth
        >
          {options.map(option => (
            <option value={option.value}>{option.placeholder}</option>
          ))}
        </NativeSelect>
      </FormControl>
    )
  }
}

DropDown.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(DropDown)



// WEBPACK FOOTER //
// ./src/components/common/DropDown.js